
import Repository from "./Repository";

const resource = "/account";


export default {
  get(part, headers) {
    return Repository.get(`${resource}/${part}`, { headers });
  },
  post(body, headers) {
    return Repository.post(`${resource}`, body, { headers });
  },
  put(body) {
    return Repository.put(`${resource}`, body);
  }

};



// WEBPACK FOOTER //
// ./src/repositories/AccountRepository.js